import SavedQueries from "@/components/admin/SavedQueries";

const Queries = () => {
  return (
    <div className="flex flex-1 flex-col min-h-0 overflow-hidden">
      <div className="flex items-center gap-1 border-b border-border bg-card px-4 md:px-6 overflow-x-auto">
        <h2 className="text-lg font-semibold mr-4">Queries</h2>
      </div>
      <div className="flex flex-1 min-h-0">
        <SavedQueries />
      </div>
    </div>
  );
};

export default Queries;
